import { ModalActionTypes } from "../action-types/modalTypes";

export const openClose = (content) => {
  return (dispatch) => {
    dispatch({
      type: ModalActionTypes.OPEN_CLOSE,
      payload: content,
    });
  };
};